// extracted by mini-css-extract-plugin
export default {"Title":"Matting_Title__WqmQ2","Controller":"Matting_Controller__n7RyR","Content":"Matting_Content__IjaGy","DragAndScale":"Matting_DragAndScale__HJfAY","Tips":"Matting_Tips__c9Phx"};